import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface FilterToolbarProps {
    children: ReactNode
    className?: string
    'data-testid'?: string
}

/**
 * Vertical stack of filter/search controls at the top of a list or master panel.
 * Provides a consistent padded, bordered toolbar so individual pages don't
 * replicate `p-3 border-b space-y-2` inline.
 */
export function FilterToolbar({children, className, 'data-testid': testId}: FilterToolbarProps) {
    return (
        <div
            className={cn('p-3 border-b space-y-2', className)}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
